import service from '../../utils/service'
import Urls from '../../utils/urlStrings'
import { MICROSERVICES } from '../../utils/constants'
import moment from 'moment'

export class DashboardService {
  async getSummary(account_id, account) {
    try {
      const response = await service.get(Urls.getApiUrl(`admin/${account_id}/summary`, MICROSERVICES.PROGRAMMANAGER), { params: { input_account_id: account } })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getOngoingEvents(user, account, page, rowsPerPage, timeZone) {
    const params = { input_account_id: account, page_no: page, page_size: rowsPerPage, start_date: moment().tz(timeZone).format('YYYY-MM-DD HH:mm:ssZ'), end_date: moment().tz(timeZone).add(14, 'days').format('YYYY-MM-DD HH:mm:ssZ'), sort_by: 'start_date_time', ascending: true }
    try {
      const response = await service.get(Urls.getApiUrl(`admin/${user.account_id}/vppevent/all`, MICROSERVICES.VPPMANAGER), { params: params })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getCompletedEvents(user, account, page, rowsPerPage, timeZone) {
    const params = { input_account_id: account, page_no: page, page_size: rowsPerPage, start_date: moment().tz(timeZone).subtract(14, 'days').format('YYYY-MM-DD HH:mm:ssZ'), end_date: moment().tz(timeZone).format('YYYY-MM-DD HH:mm:ssZ'), sort_by: 'end_date_time', ascending: false, status: 'scheduled,completed' }
    try {
      const response = await service.get(Urls.getApiUrl(`admin/${user.account_id}/vppevent/all/status`, MICROSERVICES.VPPMANAGER), { params: params })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }
}

export const dashboardService = new DashboardService()